import { useEffect, useState } from "react";

type ViewportCategory = "mobile" | "tablet" | "desktop";

const BREAKPOINTS = {
  tablet: 768,
  desktop: 1024,
};

const getViewportCategory = (width: number): ViewportCategory => {
  if (width >= BREAKPOINTS.desktop) {
    return "desktop";
  }
  if (width >= BREAKPOINTS.tablet) {
    return "tablet";
  }
  return "mobile";
};

const getInitialViewport = (): ViewportCategory => {
  if (typeof window === "undefined") {
    return "desktop";
  }
  return getViewportCategory(window.innerWidth);
};

/**
 * Report the current viewport category so components can adapt layouts
 * without hardcoding ad-hoc matchMedia checks everywhere.
 */
export function useResponsiveBreakpoint() {
  const [viewport, setViewport] = useState<ViewportCategory>(
    getInitialViewport,
  );

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const handleResize = () => {
      const next = getViewportCategory(window.innerWidth);
      setViewport((current) => (current === next ? current : next));
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    viewport,
    isMobile: viewport === "mobile",
    isTablet: viewport === "tablet",
    isDesktop: viewport === "desktop",
    isTabletUp: viewport === "tablet" || viewport === "desktop",
    isDesktopUp: viewport === "desktop",
  };
}
